export const API_BASE_URL = 'https://offer.app20.in';
export const BASE_URL = 'https://backend.app20.in';
export const WEBSITE_URL = 'https://app20.in';
export const REDDIT_KARMA_ENDPOINT = '/api/reddit-karma';

// Web3Forms (https://web3forms.com) — used for the Reddit Creator Program
// registration form. The access key is designed to be used client-side.
export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
export const WEB3FORMS_ACCESS_KEY = 'ca25af2a-0a3f-4e4c-840c-772c386c1d55';